import { call, put, select, takeLatest } from "redux-saga/effects";
import * as actionTypes from '../actions/actionTypes';
import contentRequestServices from "../services/contentRequestServices";
import { contentRequestActions } from "../reducers/contentRequestReducer";
import {contentRequestCreateActions} from "../reducers/contentRequestCreateReducer";
import ACLService from "../../acl/services/aclService";
import { 
    DateFilterOptions,
    Status,
    ContentType,
    Priority,
    Tabs,
    PriorityTitle,
    PriorityBackendKeys
 } from "../types/Constants";
import { RequestPriority } from "../types/ContentRequest";
 

// const userData: any = ACLService.getUserDetailsFromStorage();
// const isBranch = userData.authenticatedUser && userData.authenticatedUser.clientId.isBranchClient
// const isAdmin = userData.authenticatedUser && userData.authenticatedUser.isAdmin;
// const isSuperAdmin = userData.authenticatedUser && userData.authenticatedUser.isSuperAdmin;

function* getSentContentRequestsSaga(action: any) {
    try {
        const userData: any = ACLService.getUserDetailsFromStorage();
        const isBranch = userData.authenticatedUser && userData.authenticatedUser.clientId.isBranchClient
        const isAdmin = userData.authenticatedUser && userData.authenticatedUser.isAdmin;
        const isSuperAdmin = userData.authenticatedUser && userData.authenticatedUser.isSuperAdmin;
        const pageNumber:any = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageNumber
        )
        const pageSize:any = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageSize
        )
        let params = {
            type: Tabs.SentRequest,
            pageNumber: 1,
            pageSize: pageSize,
            // contentType: 'question'
        }
        const res = yield call(contentRequestServices.getSentContentRequests,isBranch, isAdmin, isSuperAdmin, params);
        yield put(
            contentRequestActions.setSentContentRequestsData(res.contentRequests)
        ) 
        yield put (
            contentRequestActions.setSentRequestsTotalPages(res.totalPages)
        )
        yield put (
            contentRequestActions.setSentRequestsTotalCount(res.totalCount)
        )
    } catch (e) {
        console.log('getSentContentRequestsSaga' + e)
    }
}

function* getContentRequestSaga(action: any) {
    try {
        const res = yield call(contentRequestServices.getContentRequest, action.payload);
        yield put(
            contentRequestActions.setContentRequest(res.responseObject)
        )

    } catch (e) {
        console.log('getContentRequestSaga' + e)
    }
}

function* getOwnerTaskByRoleSaga(action: any) {
    try {
        const res = yield call(
        contentRequestServices.getOwnerTaskByRole, action.payload.requestId, action.payload.authorType);
        yield put(
            contentRequestActions.setOwnerTaskByRoleData(res)
        ) 
    } catch (e) {
        console.log('getOwnerTaskByRoleSaga' + e)
    }
}
function* getFeedbackSaga(action: any) {
    try {
        const res = yield call(
        contentRequestServices.getFeedback, action.payload.contentRequestId, action.payload.contentId, action.payload.pageNumber);
        yield put(
            contentRequestActions.setFeedback(res)
        ) 
    } catch (e) {
        console.log('getFeedback' + e)
    }
}
function* addNewFeedbackSaga(action: any) {
    try {
        const res = yield call(
        contentRequestServices.addNewFeedback, action.payload);
        yield put(
            contentRequestActions.addNewFeedback(res)
        ) 
    } catch (e) {
        console.log('addNewFeedback' + e)
    }
}

function* resolveFeedbackSaga(action: any) {
    try {
        const res = yield call(
        contentRequestServices.resolveFeedback, action.payload);
        yield put(
            contentRequestActions.resolveFeedback(res)
        ) 
    } catch (e) {
        console.log('resolveFeedback' + e)
    }
}
function* replyFeedbackSaga(action: any) {
    try {
        const res = yield call(
        contentRequestServices.replyFeedback, action.payload);
        yield put(
            contentRequestActions.replyFeedback(res)
        ) 
    } catch (e) {
        console.log('resolveFeedback' + e)
    }
}
function* getReceivedContentRequestSaga(action: any) {
    try {
        const userData: any = ACLService.getUserDetailsFromStorage();
        const isBranch = userData.authenticatedUser && userData.authenticatedUser.clientId.isBranchClient
        const isAdmin = userData.authenticatedUser && userData.authenticatedUser.isAdmin;
        const isSuperAdmin = userData.authenticatedUser && userData.authenticatedUser.isSuperAdmin;

        const pageNumber = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageNumber
        )
        const pageSize = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageSize
        )
        let params = {
            type: Tabs.ReceivedRequest,
            pageNumber: 1,
            pageSize: pageSize,
            // contentType: 'question'
        }
        const res = yield call(contentRequestServices.getReceivedContentRequests, isBranch, isAdmin, isSuperAdmin, params);
        yield put(
            contentRequestActions.setReceivedContentRequestsData(res.contentRequests)
        )
        yield put(
            contentRequestActions.setReceivedRequestsTotalPages(res.totalPages)
        )
    } catch (e) {
        console.log('getReceivedContentRequestSaga' + e)
    }
}

function* setActiveTabSaga(action: any) {
    // TODO
    try {
        yield put(
            contentRequestActions.setActiveTab(action.payload)
        )
    } catch (e) {
        console.log('getReceivedContentRequestSaga' + e)
    }
}

function* setDateFilter(action: any) {
    try {
        const userData: any = ACLService.getUserDetailsFromStorage();
        const isBranch = userData.authenticatedUser && userData.authenticatedUser.clientId.isBranchClient
        const isAdmin = userData.authenticatedUser && userData.authenticatedUser.isAdmin;
        const isSuperAdmin = userData.authenticatedUser && userData.authenticatedUser.isSuperAdmin;

        const pageNumber = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageNumber
        )
        const pageSize = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageSize
        )
        const statusFilter = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.statusFilter
        )
        const contentType = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.contentTypeFilter
        )
        const priority = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.priorityFilter
        )

        let res;
        let params = {
            type: action.payload.activeTab,
            pageNumber: pageNumber,
            pageSize: pageSize,
            dateType: action.payload.type,
            startDate: action.payload.from,
            endDate: action.payload.to,
            activeTab: action.payload.activeTab,
            status: statusFilter.length > 0 ?  statusFilter.join(','): '',
            contentType: contentType.length > 0 ? contentType.join(',') : '',
            priority: priority.length > 0 ? priority.map((priority: string) => 
            transformPriorityKey(priority).toString()).join(',') : ''
        }

        if(action.payload.activeTab === Tabs.SentRequest){ // action.payload has the active tab
            res = yield call(contentRequestServices.getSentContentRequests, isBranch, isAdmin, isSuperAdmin, params);
            yield put(contentRequestActions.setSentContentRequestsData(res.contentRequests));
            yield put (contentRequestActions.setSentRequestsTotalPages(res.totalPages))
            yield put (contentRequestActions.setSentRequestsTotalCount(res.totalCount))
        } else {
            res = yield call(contentRequestServices.getReceivedContentRequests, isBranch, isAdmin, isSuperAdmin, params);
            yield put(contentRequestActions.setReceivedContentRequestsData(res.contentRequests));
            yield put(contentRequestActions.setReceivedRequestsTotalPages(res.totalPages))
        }

        yield put(
            contentRequestActions.setDateFilter(action.payload)
        )
    } catch (e) {
        console.log('setDateFilter' + e)
    }
}

function filterItem(itemsArray:string[], item:string) {
    const newSet = new Set([...itemsArray]);
    if(!newSet.has(item)) {
        newSet.add(item);
    } else {
        newSet.delete(item);
    }
    return Array.from(newSet)
}

function* toggleStatus(action: any) {
    try {
        

        const userData: any = ACLService.getUserDetailsFromStorage();
        const isBranch = userData.authenticatedUser && userData.authenticatedUser.clientId.isBranchClient
        const isAdmin = userData.authenticatedUser && userData.authenticatedUser.isAdmin;
        const isSuperAdmin = userData.authenticatedUser && userData.authenticatedUser.isSuperAdmin;
        const pageNumber = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageNumber
        )
        const pageSize = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageSize
        )
        const statusFilter = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.statusFilter
        )
        const contentType = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.contentTypeFilter
        )
        const priority = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.priorityFilter
        )
        const searchQuery = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.searchBar
        )
        const dateFilter = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.dateFilter
        )

        // const priority = yield select(
        //     (state: any) => state.contentRequestReducer.contentRequestReducer.priorityFilter
        // )
        let res;
        let params = {
            type: action.payload.activeTab,
            pageNumber: pageNumber,
            pageSize: pageSize,
            status: filterItem(statusFilter, action.payload.item).join(','),
            contentType: contentType.length > 0 ? contentType.join(',') : '',
            priority: priority.length > 0 ? priority.map((priority: string) => 
            transformPriorityKey(priority).toString()).join(',') : '',
            searchQuery: searchQuery.searchText,
            dateType:dateFilter.type,
            startDate:dateFilter.from,
            endDate:dateFilter.to
        }

        let checkedParams:any = {};
        for(const [key, value] of Object.entries(params)){
          console.log(`${key}: ${value}`);
          if(value !== null && value !== ""){
            checkedParams[key] = value;
          }
        }


        if(action.payload.activeTab === Tabs.SentRequest){ // action.payload has the active tab
            res = yield call(contentRequestServices.getSentContentRequests, isBranch, isAdmin, isSuperAdmin, checkedParams);
            yield put(contentRequestActions.setSentContentRequestsData(res.contentRequests));
            yield put (contentRequestActions.setSentRequestsTotalPages(res.totalPages))
            yield put (contentRequestActions.setSentRequestsTotalCount(res.totalCount))
            
        } else {
            res = yield call(contentRequestServices.getReceivedContentRequests, isBranch, isAdmin, isSuperAdmin, checkedParams);
            yield put(contentRequestActions.setReceivedContentRequestsData(res.contentRequests));
            yield put(contentRequestActions.setReceivedRequestsTotalPages(res.totalPages))
        }

        yield put(contentRequestActions.setStatusFilter(action.payload.item))

    } catch (e) {
        console.log('toggleStatus' + e)
    }
}

function* toggleContentType(action: any) {
    
    try {        
        const userData: any = ACLService.getUserDetailsFromStorage();
        const isBranch = userData.authenticatedUser && userData.authenticatedUser.clientId.isBranchClient
        const isAdmin = userData.authenticatedUser && userData.authenticatedUser.isAdmin;
        const isSuperAdmin = userData.authenticatedUser && userData.authenticatedUser.isSuperAdmin;

        const pageNumber = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageNumber
        )
        const pageSize = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageSize
        )
        const contentType = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.contentTypeFilter
        )
        const status = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.statusFilter
        )
        const priority = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.priorityFilter
        )

        const dateFilter = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.dateFilter
        )

        const searchQuery = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.searchBar
        )
        // console.log(contentTypeFilters) // Send previous filters along with newly checked filter in API call
        let res;
        let params = {
            type: action.payload.activeTab,
            pageNumber: pageNumber,
            pageSize: pageSize,
            contentType: filterItem(contentType, action.payload.item).join(','),
            status: status.length > 0 ? status.join(',') : '',
            priority: priority.length > 0 ? priority.map((priority: string) => 
            transformPriorityKey(priority).toString()).join(',') : '',
            searchQuery: searchQuery.searchText,
            dateType:dateFilter.type,
            startDate:dateFilter.from,
            endDate:dateFilter.to
        }

        let checkedParams:any = {};
        for(const [key, value] of Object.entries(params)){
          if(value !== null && value !== ""){
            checkedParams[key] = value;
          }
        }

        if(action.payload.activeTab === Tabs.SentRequest){ // action.payload has the active tab
            res = yield call(contentRequestServices.getSentContentRequests, isBranch, isAdmin, isSuperAdmin, checkedParams);
            yield put(contentRequestActions.setSentContentRequestsData(res.contentRequests));
            yield put (contentRequestActions.setSentRequestsTotalPages(res.totalPages))
            yield put (contentRequestActions.setSentRequestsTotalCount(res.totalCount))
        } else {
            res = yield call(contentRequestServices.getReceivedContentRequests, isBranch, isAdmin, isSuperAdmin, checkedParams);
            yield put(contentRequestActions.setReceivedContentRequestsData(res.contentRequests));
            yield put(contentRequestActions.setReceivedRequestsTotalPages(res.totalPages))
        }
        
        yield put(contentRequestActions.setContentTypeFilter(action.payload.item))
        
        
    } catch (e) {
        console.log('toggleContentType' + e)
    }
}

const transformPriorityKey = (priorityKeyName: any) => {
    console.log(priorityKeyName);
    switch(priorityKeyName){
        case PriorityTitle.importantAndUrgent: return RequestPriority.IMPORTANT_AND_URGENT;
        case PriorityTitle.importantButNotUrgent: return RequestPriority.IMPORTANT_BUT_NOT_URGENT;
        case PriorityTitle.notImportantButUrgent: return RequestPriority.NOT_IMPORTANT_BUT_URGENT;
        case PriorityTitle.notImportantAndNotUrgent: return RequestPriority.NOT_IMPORANT_AND_NOT_URGENT;
        default: return RequestPriority.NOT_IMPORANT_AND_NOT_URGENT;
    }
    
}

function* togglePriority(action: any) {
    try {
        const userData: any = ACLService.getUserDetailsFromStorage();
        const isBranch = userData.authenticatedUser && userData.authenticatedUser.clientId.isBranchClient
        const isAdmin = userData.authenticatedUser && userData.authenticatedUser.isAdmin;
        const isSuperAdmin = userData.authenticatedUser && userData.authenticatedUser.isSuperAdmin;

        const pageNumber = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageNumber
        )
        const pageSize = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageSize
        )
        const contentType = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.contentTypeFilter
        )
        const status = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.statusFilter
        )
        const priorityFilter = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.priorityFilter
        )

        const dateFilter = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.dateFilter
        )

        let params = {
            type: action.payload.activeTab,
            pageNumber: pageNumber,
            pageSize: pageSize,
            priority: filterItem([...priorityFilter.map((priority: string) => 
                transformPriorityKey(priority).toString())], transformPriorityKey(action.payload.item)).join(','), 
            status: status.length > 0 ? status.join(',') : '',
            contentType: contentType.length > 0 ? contentType.join(',') : '',
            dateType:dateFilter.type,
            startDate:dateFilter.from,
            endDate:dateFilter.to
        };

        let checkedParams:any = {};
        for(const [key, value] of Object.entries(params)){
          console.log(`${key}: ${value}`);
          if(value !== null && value !== ""){
            checkedParams[key] = value;
          }
        }

        
        let res;
        if(action.payload.activeTab === Tabs.SentRequest){ // action.payload has the active tab
            res = yield call(contentRequestServices.getSentContentRequests, isBranch, isAdmin, isSuperAdmin, checkedParams);
            
            yield put(contentRequestActions.setSentContentRequestsData(res.contentRequests));
            yield put (contentRequestActions.setSentRequestsTotalPages(res.totalPages))
            yield put (contentRequestActions.setSentRequestsTotalCount(res.totalCount))
		
        } else {
            res = yield call(contentRequestServices.getReceivedContentRequests, isBranch, isAdmin, isSuperAdmin, checkedParams);
            
            yield put(contentRequestActions.setReceivedContentRequestsData(res.contentRequests));
            yield put(contentRequestActions.setReceivedRequestsTotalPages(res.totalPages))
        }

        yield put(contentRequestActions.setPriorityFilter(action.payload.item))
    } catch (e) {
        console.log('togglePriority' + e)
    }
}


function* setSearchTextSaga(action: any) {
    try {

        const pageNumber = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageNumber
        )
        const pageSize = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageSize
        )
        const contentType = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.contentTypeFilter
        )
        const status = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.statusFilter
        )
        const priorityFilter = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.priorityFilter
        )
        const dateFilter = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.dateFilter
        )

        let params = {
            type: action.payload.activeTab,
            pageNumber: pageNumber,
            pageSize: pageSize,
            dateType: dateFilter.type,
            startDate: dateFilter.from,
            endDate: dateFilter.to,
            status: status.length > 0 ? status.join(',') : '',
            contentType: contentType.length > 0 ? contentType.join(',') : '',
            priority: [...priorityFilter.map((priority: string) => 
                transformPriorityKey(priority).toString())].join(','),
            searchQuery: action.payload.searchText
        };

        let checkedParams:any = {};
        for(const [key, value] of Object.entries(params)){
          console.log(`${key}: ${value}`);
          if(value !== null && value !== ""){
            checkedParams[key] = value;
          }
        }

        let res;
        if(action.payload.activeTab === Tabs.SentRequest){ // action.payload has the active tab
            res = yield call(contentRequestServices.searchContentRequests, checkedParams);
            yield put(contentRequestActions.setSentContentRequestsData(res.contentRequests));
            yield put (contentRequestActions.setSentRequestsTotalPages(res.totalPages))
            yield put (contentRequestActions.setSentRequestsTotalCount(res.totalCount))
		
        } else {
            res = yield call(contentRequestServices.searchContentRequests, checkedParams);
            yield put(contentRequestActions.setReceivedContentRequestsData(res.contentRequests));
            yield put(contentRequestActions.setReceivedRequestsTotalPages(res.totalPages))
        }

        yield put(
            contentRequestActions.setSearchBar(action.payload)
            )
    } catch (e) {
        console.log('setSearchTextSaga' + e)
    }
}

function* deleteContentRequestSaga(action: any) {
    const res = yield call(contentRequestServices.deleteContentRequest, action.payload.id);
    switch(action.payload.activeTab){
        case Tabs.SentRequest:
            try {
                const userData: any = ACLService.getUserDetailsFromStorage();
                const isBranch = userData.authenticatedUser && userData.authenticatedUser.clientId.isBranchClient;
                const isAdmin = userData.authenticatedUser && userData.authenticatedUser.isAdmin;
                const isSuperAdmin = userData.authenticatedUser && userData.authenticatedUser.isSuperAdmin;
        
                const pageNumber = yield select(
                    (state: any) => state.contentRequestReducer.contentRequestReducer.pageNumber
                )
                const pageSize = yield select(
                    (state: any) => state.contentRequestReducer.contentRequestReducer.pageSize
                )
                let params = {
                    type: Tabs.SentRequest,
                    pageNumber: pageNumber,
                    pageSize: pageSize,
                    // contentType: 'question'
                }
                const res = yield call(contentRequestServices.getSentContentRequests,isBranch, isAdmin, isSuperAdmin, params);
        
                yield put(
                    contentRequestActions.setSentContentRequestsData(res.contentRequests)
                ) 
                yield put (
                    contentRequestActions.setSentRequestsTotalPages(res.totalPages)
                )
                yield put (contentRequestActions.setSentRequestsTotalCount(res.totalCount))
            } catch (e) {
                console.log('getSentContentRequestsSaga' + e)
            }
            break;
        case Tabs.ReceivedRequest:
            try {
                const userData: any = ACLService.getUserDetailsFromStorage();
                const isBranch = userData.authenticatedUser && userData.authenticatedUser.clientId.isBranchClient
                const isAdmin = userData.authenticatedUser && userData.authenticatedUser.isAdmin;
                const isSuperAdmin = userData.authenticatedUser && userData.authenticatedUser.isSuperAdmin;
        
                const pageNumber = yield select(
                    (state: any) => state.contentRequestReducer.contentRequestReducer.pageNumber
                )
                const pageSize = yield select(
                    (state: any) => state.contentRequestReducer.contentRequestReducer.pageSize
                )
                let params = {
                    type: Tabs.ReceivedRequest,
                    pageNumber: pageNumber,
                    pageSize: pageSize,
                    // contentType: 'question'
                }
                const res = yield call(contentRequestServices.getReceivedContentRequests, isBranch, isAdmin, isSuperAdmin, params);
                yield put(
                    contentRequestActions.setReceivedContentRequestsData(res.contentRequests)
                )
                yield put(
                    contentRequestActions.setReceivedRequestsTotalPages(res.totalPages)
                )
            } catch (e) {
                console.log('getReceivedContentRequestSaga' + e)
            }
        default:
    }
    try {
        yield put(
            contentRequestActions.setDeleteStatus(res.responseObject)
        )
    } catch (e) {
        console.log('deleteContentRequestSaga' + e)
    }
}

// function* editContentRequestSaga(action: any) {
//     try {
//         yield put({
//             type: actionTypes.EDIT_CONTENT_REQUEST_SUCCESS,
//             payload: action.payload
//         })
//     } catch (e) {
//         console.log('editContentRequestSaga' + e)
//     }
// }

function* nextPageSaga(action: any){
try {
  
    const userData: any = ACLService.getUserDetailsFromStorage();
    const isBranch = userData.authenticatedUser && userData.authenticatedUser.clientId.isBranchClient
    const isAdmin = userData.authenticatedUser && userData.authenticatedUser.isAdmin;
    const isSuperAdmin = userData.authenticatedUser && userData.authenticatedUser.isSuperAdmin;

    const activeTab = yield select(
        (state: any) => state.contentRequestReducer.contentRequestReducer.activeTab
    )
    const pageNumber = yield select(
        (state: any) => state.contentRequestReducer.contentRequestReducer.pageNumber
    )
    const pageSize = yield select(
        (state: any) => state.contentRequestReducer.contentRequestReducer.pageSize
    )
    const dateFilter = yield select(
        (state: any) => state.contentRequestReducer.contentRequestReducer.dateFilter
    )
    const statusFilter = yield select(
        (state: any) => state.contentRequestReducer.contentRequestReducer.statusFilter
    )
    const contentType = yield select(
        (state: any) => state.contentRequestReducer.contentRequestReducer.contentTypeFilter
    )
    const priority = yield select(
        (state: any) => state.contentRequestReducer.contentRequestReducer.priorityFilter
    )
    const searchBar = yield select(
        (state: any) => state.contentRequestReducer.contentRequestReducer.searchBar
    )

    let params = {
        type: activeTab,
        pageNumber: action.payload.pageNumber,
        pageSize: pageSize,
        dateType: dateFilter.type,
        startDate: dateFilter.from,
        endDate: dateFilter.to,
        status: statusFilter.length > 0 ? statusFilter.join(',') : '',
        contentType: contentType.length > 0 ? contentType.join(',') : '',
        priority: [...priority.map((priority: string) => 
            transformPriorityKey(priority).toString())].join(','),
        searchQuery: searchBar.searchText
    };

    let checkedParams:any = {};
    for(const [key, value] of Object.entries(params)){
      console.log(`${key}: ${value}`);
      if(value !== null && value !== ""){
        checkedParams[key] = value;
      }
    }

    let res;
    if(action.payload.activeTab === Tabs.SentRequest){ // action.payload has the active tab
        res = yield call(contentRequestServices.getSentContentRequests, isBranch, isAdmin, isSuperAdmin, checkedParams);
        yield put(contentRequestActions.setSentContentRequestsData(res.contentRequests));
        
    } else {
        res = yield call(contentRequestServices.getReceivedContentRequests, isBranch, isAdmin, isSuperAdmin, checkedParams);
        yield put(contentRequestActions.setReceivedContentRequestsData(res.contentRequests));
    }

    yield put(contentRequestActions.setCurrentPage(action.payload.pageNumber));
} catch (e) {
    console.log('nextPageSaga' + e)
}
}

function* updateCurrentPageSaga(action: any){
    try {
        const activeTab = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.activeTab
        )
        const pageNumber = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageNumber
        )
        const pageSize = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageSize
        )
        const dateFilter = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.dateFilter
        )
        const statusFilter = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.statusFilter
        )
        const contentType = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.contentTypeFilter
        )
        const priority = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.priorityFilter
        )
        const searchBar = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.searchBar
        )

        let params = {
            type: activeTab,
            pageNumber: action.payload.pageNumber,
            pageSize: pageSize,
            dateType: dateFilter.type,
            startDate: dateFilter.from,
            endDate: dateFilter.to,
            status: statusFilter && statusFilter.length > 0 ? statusFilter.join(',') : '',
            contentType: contentType && contentType.length > 0 ? contentType.join(',') : '',
            priority: [...priority.map((priority: string) => 
                transformPriorityKey(priority).toString())].join(','),
            searchQuery: searchBar.searchText
        };

        let checkedParams:any = {};
        for(const [key, value] of Object.entries(params)){
          console.log(`${key}: ${value}`);
          if(value !== null && value !== ""){
            checkedParams[key] = value;
          }
        }

        let res;
        if(action.payload.activeTab === Tabs.SentRequest){ // action.payload has the active tab
            res = yield call(contentRequestServices.searchContentRequests, checkedParams);
            yield put(contentRequestActions.setSentContentRequestsData(res.contentRequests));
        } else {
            res = yield call(contentRequestServices.searchContentRequests, checkedParams);
            yield put(contentRequestActions.setReceivedContentRequestsData(res.contentRequests));
        }
      

       yield put(contentRequestActions.setCurrentPage(action.payload));

    } catch (e) {
        console.log('nextPageSaga' + e)
    }
    }

function* prevPageSaga(action: any){
try {
    const userData: any = ACLService.getUserDetailsFromStorage();
    const isBranch = userData.authenticatedUser && userData.authenticatedUser.clientId.isBranchClient
    const isAdmin = userData.authenticatedUser && userData.authenticatedUser.isAdmin;
    const isSuperAdmin = userData.authenticatedUser && userData.authenticatedUser.isSuperAdmin;


    const activeTab = yield select(
        (state: any) => state.contentRequestReducer.contentRequestReducer.activeTab
    )
    const pageNumber = yield select(
        (state: any) => state.contentRequestReducer.contentRequestReducer.pageNumber
    )
    const pageSize = yield select(
        (state: any) => state.contentRequestReducer.contentRequestReducer.pageSize
    )
    const dateFilter = yield select(
        (state: any) => state.contentRequestReducer.contentRequestReducer.dateFilter
    )
    const statusFilter = yield select(
        (state: any) => state.contentRequestReducer.contentRequestReducer.statusFilter
    )
    const contentType = yield select(
        (state: any) => state.contentRequestReducer.contentRequestReducer.contentTypeFilter
    )
    const priority = yield select(
        (state: any) => state.contentRequestReducer.contentRequestReducer.priorityFilter
    )
    const searchBar = yield select(
        (state: any) => state.contentRequestReducer.contentRequestReducer.searchBar
    )

    let params = {
        type: activeTab,
        pageNumber: action.payload.pageNumber,
        pageSize: pageSize,
        dateType: dateFilter.type,
        startDate: dateFilter.from,
        endDate: dateFilter.to,
        status: statusFilter.length > 0 ? statusFilter.join(',') : '',
        contentType: contentType.length > 0 ? contentType.join(',') : '',
        priority: [...priority.map((priority: string) => 
            transformPriorityKey(priority).toString())].join(','),
        searchQuery: searchBar.searchText
    };

    let checkedParams:any = {};
    for(const [key, value] of Object.entries(params)){
      console.log(`${key}: ${value}`);
      if(value !== null && value !== ""){
        checkedParams[key] = value;
      }
    }


    let res;
    if(action.payload.activeTab === Tabs.SentRequest){ // action.payload has the active tab
        res = yield call(contentRequestServices.getSentContentRequests, isBranch, isAdmin, isSuperAdmin, checkedParams);
        yield put(contentRequestActions.setSentContentRequestsData(res.contentRequests));
    } else {
        res = yield call(contentRequestServices.getReceivedContentRequests, isBranch, isAdmin, isSuperAdmin, checkedParams);
        yield put(contentRequestActions.setReceivedContentRequestsData(res.contentRequests));
    }

    yield put(contentRequestActions.setCurrentPage(action.payload.pageNumber));

} catch (e) {
    console.log('prevPageSaga' + e)
}
}

function* firstPageSaga(action: any){
    try {
        const userData: any = ACLService.getUserDetailsFromStorage();
        const isBranch = userData.authenticatedUser && userData.authenticatedUser.clientId.isBranchClient
        const isAdmin = userData.authenticatedUser && userData.authenticatedUser.isAdmin;
        const isSuperAdmin = userData.authenticatedUser && userData.authenticatedUser.isSuperAdmin;

        const activeTab = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.activeTab
        )
        const pageNumber = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageNumber
        )
        const pageSize = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageSize
        )
        const dateFilter = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.dateFilter
        )
        const statusFilter = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.statusFilter
        )
        const contentType = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.contentTypeFilter
        )
        const priority = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.priorityFilter
        )
        const searchBar = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.searchBar
        )
    
        let params = {
            type: activeTab,
            pageNumber: 1,
            pageSize: pageSize,
            dateType: dateFilter.type,
            startDate: dateFilter.from,
            endDate: dateFilter.to,
            status: statusFilter.length > 0 ? statusFilter.join(',') : '',
            contentType: contentType.length > 0 ? contentType.join(',') : '',
            priority: [...priority.map((priority: string) => 
                transformPriorityKey(priority).toString())].join(','),
            searchQuery: searchBar.searchText
        };
    
        let checkedParams:any = {};
        for(const [key, value] of Object.entries(params)){
          console.log(`${key}: ${value}`);
          if(value !== null && value !== ""){
            checkedParams[key] = value;
          }
        }
    
        let res;
        if(action.payload.activeTab === Tabs.SentRequest){ // action.payload has the active tab
            res = yield call(contentRequestServices.getSentContentRequests, isBranch, isAdmin, isSuperAdmin, checkedParams);
            yield put(contentRequestActions.setSentContentRequestsData(res.contentRequests));
        } else {
            res = yield call(contentRequestServices.getReceivedContentRequests, isBranch, isAdmin, isSuperAdmin, checkedParams);
            yield put(contentRequestActions.setReceivedContentRequestsData(res.contentRequests));
        }

        yield put(contentRequestActions.setCurrentPage(1));

    } catch (e) {
        console.log('firstPageSaga' + e)
    }
}

function* lastPageSaga(action: any){
    try {
        const userData: any = ACLService.getUserDetailsFromStorage();
        const isBranch = userData.authenticatedUser && userData.authenticatedUser.clientId.isBranchClient
        const isAdmin = userData.authenticatedUser && userData.authenticatedUser.isAdmin;
        const isSuperAdmin = userData.authenticatedUser && userData.authenticatedUser.isSuperAdmin;

        const activeTab = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.activeTab
        )
        const pageNumber = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageNumber
        )
        const pageSize = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.pageSize
        )
        const dateFilter = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.dateFilter
        )
        const statusFilter = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.statusFilter
        )
        const contentType = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.contentTypeFilter
        )
        const priority = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.priorityFilter
        )
        const searchBar = yield select(
            (state: any) => state.contentRequestReducer.contentRequestReducer.searchBar
        )

        let lastPage;
        if (action.payload.activeTab === Tabs.SentRequest) {
            lastPage = yield select(
                (state: any) => state.contentRequestReducer.contentRequestReducer.sentRequestsTotalPages
            )
        } else {
            lastPage = yield select(
                (state: any) => state.contentRequestReducer.contentRequestReducer.receivedRequestTotalPages
            )
        }

        let params = {
            type: activeTab,
            pageNumber: lastPage,
            pageSize: pageSize,
            dateType: dateFilter.type,
            startDate: dateFilter.from,
            endDate: dateFilter.to,
            status: statusFilter.length > 0 ? statusFilter.join(',') : '',
            contentType: contentType.length > 0 ? contentType.join(',') : '',
            priority: [...priority.map((priority: string) => 
                transformPriorityKey(priority).toString())].join(','),
            searchQuery: searchBar.searchText
        };
    
        let checkedParams:any = {};
        for(const [key, value] of Object.entries(params)){
          console.log(`${key}: ${value}`);
          if(value !== null && value !== ""){
            checkedParams[key] = value;
          }
        }

        let res;
        if(action.payload.activeTab === Tabs.SentRequest){ // action.payload has the active tab
            res = yield call(contentRequestServices.getSentContentRequests, isBranch, isAdmin, isSuperAdmin, checkedParams);
            yield put(contentRequestActions.setSentContentRequestsData(res.contentRequests));
        } else {
            res = yield call(contentRequestServices.getReceivedContentRequests, isBranch, isAdmin, isSuperAdmin, checkedParams);
            yield put(contentRequestActions.setReceivedContentRequestsData(res.contentRequests));
        }

        yield put(contentRequestActions.setCurrentPage(lastPage));

    } catch (e) {
        console.log('lastPageSaga' + e)
    }
}
function* fetchAllSubjects(action: any) {
    try {
        let data = { subjects: [] };
        if(action.payload && action.payload.length > 0) {
            const res = yield call(contentRequestServices.getSubjects,action.payload);
            data = res.responseObject
        }
        yield put(
            contentRequestCreateActions.fetchSubjects(data)
        )
    } catch (e) {
        console.log('fetchSubjects' + e);
    }
}
function* addSubject(action: any) {
    try {
        yield put(
            contentRequestCreateActions.addSubjects(action.payload)
        )
    } catch (e) {
        console.log('addsubject' + e);
    }
}

function* fetchAllOwners(action: any) {
    try {
    const res = yield call(contentRequestServices.getOwners);
        yield put(
            contentRequestCreateActions.fetchOwners(res.responseObject)
        )
    } catch (e) {
        console.log('fetchSubjects' + e);
    }
}
function* setUserRoleMap(action: any) {
    try {
        yield put(
            contentRequestCreateActions.setUserRoleMap(action.payload)
        )
    } catch (e) {
        console.log('inRole' + e);
    }
}
function* contentRequestSaga() {
    yield takeLatest(actionTypes.GET_SENT_CONTENT_REQUEST, getSentContentRequestsSaga);
    yield takeLatest(actionTypes.GET_RECEIVED_CONTENT_REQUEST, getReceivedContentRequestSaga);
    yield takeLatest(actionTypes.GET_CONTENT_REQUEST, getContentRequestSaga);
    yield takeLatest(actionTypes.SET_ACTIVE_TAB, setActiveTabSaga)
    yield takeLatest(actionTypes.SET_DATE_FILTER, setDateFilter);
    yield takeLatest(actionTypes.TOGGLE_STATUS, toggleStatus);
    yield takeLatest(actionTypes.TOGGLE_CONTENT_TYPE, toggleContentType);
    yield takeLatest(actionTypes.TOGGLE_PRIORITY, togglePriority);
    yield takeLatest(actionTypes.SET_SEARCH_TEXT, setSearchTextSaga);
    yield takeLatest(actionTypes.GET_OWNER_TASK_BY_ROLE, getOwnerTaskByRoleSaga);
    yield takeLatest(actionTypes.GET_FEEDBACK, getFeedbackSaga);
    yield takeLatest(actionTypes.ADD_NEW_FEEDBACK, addNewFeedbackSaga);
    yield takeLatest(actionTypes.RESOLVE_FEEDBACK, resolveFeedbackSaga);
    yield takeLatest(actionTypes.REPLY_FEEDBACK, replyFeedbackSaga);
    yield takeLatest(actionTypes.NEXT_PAGE, nextPageSaga)
    yield takeLatest(actionTypes.UPDATE_CURRENT_PAGE, updateCurrentPageSaga)
    yield takeLatest(actionTypes.PREVIOUS_PAGE, prevPageSaga)
    yield takeLatest(actionTypes.FIRST_PAGE, firstPageSaga)
    yield takeLatest(actionTypes.LAST_PAGE, lastPageSaga)
    yield takeLatest(actionTypes.FETCH_SUBJECTS, fetchAllSubjects)
    yield takeLatest(actionTypes.ADD_SUBJECT, addSubject)
    yield takeLatest(actionTypes.FETCH_OWNERS, fetchAllOwners)
    yield takeLatest(actionTypes.DELETE_CONTENT_REQUEST, deleteContentRequestSaga);
    // yield takeLatest(actionTypes.EDIT_CONTENT_REQUEST, editContentRequestSaga);
    yield takeLatest(actionTypes.ADD_AUTHOR_ROLE, setUserRoleMap);
}

export default contentRequestSaga